import { createMutationHook } from '~/shared/providers/api';

export const useDeleteDetentionMutation = createMutationHook(
  'transportation.detentionDelete',
  (params: { id: string }) => ({
    transportationDetentionDelete: {
      __args: {
        id: params.id,
      },
    },
  }),
);
